import ky from "ky";
import { defaultTimeout } from "./constant";

const baseClient = ky.create({
  timeout: defaultTimeout
});

export default baseClient;
